import { Box, Grid, Typography } from "@material-ui/core";
import { useTokenAnalysisSelector } from "src/context/tokenAnalysisContext";
import { compactNumber } from "src/services/utils";

const ActivityTitle = ({ title, value, subTitle }) => {
  return (
    <Box>
      <Typography color="textSecondary" style={{ fontSize: "12px", fontWeight: 400 }}>
        {title}
      </Typography>
      <Typography style={{ color: "#0060C0" }} variant="h4">
        {value}
      </Typography>
      <Typography color="textSecondary" style={{ fontSize: "12px", fontWeight: 400 }}>
        {subTitle}
      </Typography>
    </Box>
  );
};

export default function ActivityInfo({ token, ...props }) {
  const numberOfTokens = useTokenAnalysisSelector((state) => state.numberOfTokens);

  return (
    <>
      <Box pb={1} {...props}>
        <Typography variant="h4">Activity</Typography>
      </Box>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        <Grid item xs={6} sm={4} md={2}>
          <ActivityTitle
            title="Price"
            value={`$${compactNumber(token.price, 2)}`}
            subTitle={`Highest: $${token.highest_price}`}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={2}>
          <ActivityTitle
            title="Price Stability"
            value={`${compactNumber(token.price_stability, 2)}%`}
            subTitle={`Rank ${token.rank_stable}/${numberOfTokens}`}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={2}>
          <ActivityTitle
            title="Market Cap"
            value={`$${compactNumber(token.market_cap)}`}
            subTitle={`Rank ${token.rank_market_cap}/${numberOfTokens}`}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={2}>
          <ActivityTitle
            title="Volume 24h"
            value={`$${compactNumber(token.trading_volume_24h)}`}
            subTitle={`Rank ${token.rank_trading_volume_24h}/${numberOfTokens}`}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={2}>
          <ActivityTitle
            title="Daily Tx"
            value={`${compactNumber(token.daily_transaction)}`}
            subTitle={`Rank ${token.rank_daily_transactions}/${numberOfTokens}`}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={2}>
          <ActivityTitle
            title="Holder"
            value={`${compactNumber(token.holder)}`}
            subTitle={`Rank ${token.rank_holders}/${numberOfTokens}`}
          />
        </Grid>
      </Grid>
    </>
  );
}
